export default __webpack_public_path__ + "static/1077-7c49cac43717a821877ed2d1b98aa031.gif";